import 'primeicons/primeicons.css'
import './tailwind.css'
import './legacy-bridge.scss'

import PrimeVue from 'primevue/config'
import type { App } from 'vue'

import { applyColorScheme, readStoredScheme } from './color-scheme'
import { SkileoPreset } from './preset'

export { applyColorScheme, type ColorScheme, readStoredScheme, useColorScheme } from './color-scheme'
export { softwareColors } from './palettes'
export { SkileoPreset } from './preset'

/**
 * Boot step "theme": PrimeVue 4 in styled mode with the Skileo preset (ARCHITECTURE.md §5), and the stored colour
 * scheme applied before the first render so a dark session does not flash light.
 */
export function installTheme(app: App): void {
  applyColorScheme(readStoredScheme(), { persist: false })
  app.use(PrimeVue, {
    theme: {
      preset: SkileoPreset,
      options: {
        prefix: 'p',
        // The navbar's switch sets this class on <html> (`color-scheme.ts`); the operating system's preference is
        // not followed on its own (legacy had no dark mode: themeConfig.js skin 'light', no DarkToggler mounted).
        darkModeSelector: '.skileo-dark',
        cssLayer: { name: 'primevue', order: 'theme, base, primevue, components, utilities' },
      },
    },
  })
}
